module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am18-93018152d7b86303f30cb375c9334d71.jpg";